import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import validation from '../../../validation'
import TextArea from '../../controls/TextArea'

export default {
  name: 'Review of Systems',
  group: 'Case Details',
  sectionNumber: 3,
  validationSchema: getValidationSchema(),
  Component,
}

function getValidationSchema() {
  return validation.object({
    neurological: validation.richText('Neurological'),
    cardiac: validation.richText('Cardiac'),
    pulmonary: validation.richText('Pulmonary'),
    gigu: validation.richText('GI/GU'),
    musculoskeletal: validation.richText('Musculoskeletal'),
    skin: validation.richText('Skin-integumentary'),
  })
}

function Component({ caseModel, createInputProps, getValue, setModelValue, ErrorMessage }) {
  const rows = 4

  const renderField = (name, label, helpText) => (
    <div className="col-md-6">
      <div className="form-group">
        <label className="form-label mt-2" htmlFor={`systems.${name}`}>
          {label}{' '}
          <OverlayTrigger placement="right" overlay={<Tooltip id={`tooltip-${name}`}>{helpText}</Tooltip>}>
            <i
              className="fa fa-question-circle"
              style={{ fontSize: '0.9rem', cursor: 'pointer', color: '#2f5496', marginLeft: '5px' }}
            />
          </OverlayTrigger>
        </label>
        <TextArea
          areaProps={{ ...createInputProps(`systems.${name}`) }}
          rows={rows}
          maxLength={validation.maxLengths.richText}
        />
        <div style={{ display: 'inline' }}>
          <ErrorMessage name={`systems.${name}`} />
        </div>
      </div>
    </div>
  )

  return (
    <div>
      <h4 className="pb-3">Review of Systems</h4>
      <div className="form-row">
        {renderField(
          'neurological',
          'Neurological',
          'Memory, processing, Glasgow coma scale/level of consciousness, sensation',
        )}
        {renderField('cardiac', 'Cardiac', 'Meds for HTN, blood thinner, circulation, cardiac history')}
      </div>
      <div className="form-row">
        {renderField('pulmonary', 'Pulmonary', 'C-pap, Asthma, COPD, wears O2, intubated, respiratory history')}
        {renderField(
          'gigu',
          'GI/GU',
          'Appetite, Digestive issues, bowel issues, colostomy, Urinary incontinence/retention, foley catheter',
        )}
      </div>
      <div className="form-row">
        {renderField(
          'musculoskeletal',
          'Musculoskeletal',
          'Weakness, fall history, issues with mobility, bone/muscle health, gait assessment, endurance',
        )}
        {renderField('skin', 'Skin-integumentary', 'Wounds, amputation, incisions, scars')}
      </div>
    </div>
  )
}
